/**
 * Environment constants
 * The pipeline injects CI_ENVIRONMENT_NAME with either `staging` or `production`, defaulting to `development`
 *
 * @author Matthew Rawson @ 17/10/2017 16:31
 * @type {string}
 */
export const LOCAL = "local"
export const DEVELOPMENT = "development"
export const STAGING = "staging"
export const PRODUCTION = "production"

export default {DEVELOPMENT, LOCAL, STAGING, PRODUCTION}
